import React from 'react';

import { twMerge } from 'tailwind-merge';

import { useIsTabletScreenWidthOrWider } from '../../../../../../helpers/hooks/useScreenWidth';
import { Avatar, AvatarSize } from '../../../../../Avatar/Avatar';
import { Heading } from '../../../../../Heading/Heading';
import { Text } from '../../../../../Text/Text';

interface UserInformationProps {
  className?: string;
  userAvatarUrl: string;
  userNickname: string;
}

export const UserInformation = ({
  className,
  userAvatarUrl,
  userNickname,
}: UserInformationProps) => {
  const isTabletScreenWidthOrWider = useIsTabletScreenWidthOrWider();
  const avatarSize = isTabletScreenWidthOrWider
    ? AvatarSize.REGISTRY_WALL_SMALL
    : AvatarSize.REGISTRY_WALL_MEDIUM;
  const headingContent = `Discover more from ${userNickname}`;

  return (
    <section className={twMerge('mb-8 w-full', className)}>
      <Avatar
        alt={`${userNickname} avatar`}
        src={userAvatarUrl}
        size={avatarSize}
        className="mx-auto mb-6"
      />
      <Heading className="mb-3 overflow-hidden text-ellipsis text-center" variant="sm">
        {headingContent}
      </Heading>
      <Text className="m-0 text-center" variant="sm">
        Download the Fishbrain app and explore all comments, catches, gear used and connect with{' '}
        <span className="font-semibold">{userNickname}</span> and others
      </Text>
    </section>
  );
};
